import React, { useEffect, useRef } from "react";
import { Typography, useTheme } from "@material-ui/core";
import { useAnnouncementContext } from "../../../context/announcement.context";

interface BannerProps {
    message?: string;
}

export const AnnouncementBanner: React.FC<BannerProps> = ({ message }) => {
    const theme = useTheme();
    const { announcement, setBannerHeight } = useAnnouncementContext();
    const bannerRef = useRef<HTMLDivElement>(null);

    const announcementText = message || announcement || "";

    useEffect(() => {
        if (bannerRef.current) {
            setBannerHeight(bannerRef.current.offsetHeight);
        } else {
            setBannerHeight(0);
        }
    }, [announcementText, setBannerHeight]);

    if (!announcementText) return null;

    return (
        <div
            className="no-print"
            ref={bannerRef}
            style={{
                width: "100%",
                backgroundColor: theme.palette.primary.main,
                textAlign: "center",
                padding: theme.spacing(1),
                zIndex: 2000,
                position: "fixed",
                top: 0,
                left: 0,
                fontFamily: theme.typography.fontFamily,
            }}
        >
            <Typography
                component="div"
                style={{
                    color: theme.palette.getContrastText(theme.palette.primary.main),
                    fontSize: 20,
                    fontWeight: 500,
                }}
            >
                SERVICE ANNOUNCEMENT
                {announcementText && <div>{announcementText}</div>}
            </Typography>
        </div>
    );
};
